import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "gestao-tab" }
const _hoisted_2 = { class: "gestao-toolbar" }
const _hoisted_3 = {
  class: "filter-wrap",
  ref: "filterWrapEl"
}
const _hoisted_4 = {
  key: 0,
  class: "filter-badge"
}
const _hoisted_5 = {
  key: 0,
  class: "filter-dropdown"
}
const _hoisted_6 = { class: "filter-opt" }
const _hoisted_7 = ["checked"]
const _hoisted_8 = ["checked", "onChange"]
const _hoisted_9 = { class: "filter-count" }
const _hoisted_10 = { class: "filter-opt" }
const _hoisted_11 = ["checked"]
const _hoisted_12 = { class: "filter-count" }
const _hoisted_13 = { class: "view-toggle" }
const _hoisted_14 = { class: "date-pick-wrap" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "date-label" }
const _hoisted_17 = {
  key: 0,
  class: "gestao-empty"
}
const _hoisted_18 = {
  key: 1,
  class: "gestao-empty"
}
const _hoisted_19 = {
  key: 2,
  class: "folders-list"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "folder-icon" }
const _hoisted_22 = {
  key: 0,
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_23 = {
  key: 1,
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_24 = { class: "folder-name" }
const _hoisted_25 = { class: "folder-stats" }
const _hoisted_26 = { class: "folder-stat folder-stat--present" }
const _hoisted_27 = { class: "folder-stat folder-stat--absent" }
const _hoisted_28 = { class: "folder-count" }
const _hoisted_29 = {
  key: 0,
  class: "folder-content"
}
const _hoisted_30 = { class: "user-card-head" }
const _hoisted_31 = { class: "uc-avatar" }
const _hoisted_32 = ["src"]
const _hoisted_33 = {
  key: 1,
  class: "uc-initials"
}
const _hoisted_34 = { class: "uc-identity" }
const _hoisted_35 = { class: "uc-name" }
const _hoisted_36 = { class: "uc-username" }
const _hoisted_37 = {
  key: 0,
  class: "uc-role"
}
const _hoisted_38 = {
  key: 0,
  class: "uc-assignments"
}
const _hoisted_39 = {
  key: 0,
  class: "streak-badge"
}
const _hoisted_40 = {
  key: 1,
  class: "uc-assignments"
}
const _hoisted_41 = {
  key: 0,
  class: "assign-list"
}
const _hoisted_42 = { class: "assign-section-label" }
const _hoisted_43 = { class: "chip-sub" }
const _hoisted_44 = {
  key: 0,
  class: "chip-streak"
}
const _hoisted_45 = {
  key: 1,
  class: "assign-empty"
}
const _hoisted_46 = {
  key: 2,
  class: "unassigned-badge"
}
const _hoisted_47 = {
  key: 3,
  class: "streak-badge"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: _normalizeClass(["btn-toolbar", { active: _ctx.filterOpen }]),
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.filterOpen = !_ctx.filterOpen))
        }, [
          _cache[9] || (_cache[9] = _createElementVNode("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, [
            _createElementVNode("polygon", { points: "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" })
          ], -1)),
          _cache[10] || (_cache[10] = _createTextVNode(" Filtrar cargos ", -1)),
          (_ctx.activeFilterCount > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.activeFilterCount), 1))
            : _createCommentVNode("", true)
        ], 2),
        (_ctx.filterOpen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "filter-title" }, "Cargos visíveis", -1)),
              _createElementVNode("label", _hoisted_6, [
                _createElementVNode("input", {
                  type: "checkbox",
                  checked: _ctx.filterRoleIds.length === 0,
                  onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clearFilter && _ctx.clearFilter(...args)))
                }, null, 40, _hoisted_7),
                _cache[11] || (_cache[11] = _createElementVNode("span", null, "Todos", -1))
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roles, (role) => {
                return (_openBlock(), _createElementBlock("label", {
                  key: role.id,
                  class: "filter-opt"
                }, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    checked: _ctx.filterRoleIds.includes(role.id),
                    onChange: ($event: any) => (_ctx.toggleFilter(role.id))
                  }, null, 40, _hoisted_8),
                  _createElementVNode("span", null, _toDisplayString(role.name), 1),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.countByRole(role.id)), 1)
                ]))
              }), 128)),
              _createElementVNode("label", _hoisted_10, [
                _createElementVNode("input", {
                  type: "checkbox",
                  checked: _ctx.filterRoleIds.includes('__none__'),
                  onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleFilter('__none__')))
                }, null, 40, _hoisted_11),
                _cache[12] || (_cache[12] = _createElementVNode("span", null, "Sem cargo", -1)),
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.countByRole('__none__')), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ], 512),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["toggle-btn", { active: _ctx.viewMode === 'projects' }]),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setViewMode('projects')))
        }, [...(_cache[14] || (_cache[14] = [
          _createStaticVNode("<svg width=\"13\" height=\"13\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-3442f67f><rect x=\"3\" y=\"3\" width=\"7\" height=\"7\" data-v-3442f67f></rect><rect x=\"14\" y=\"3\" width=\"7\" height=\"7\" data-v-3442f67f></rect><rect x=\"14\" y=\"14\" width=\"7\" height=\"7\" data-v-3442f67f></rect><rect x=\"3\" y=\"14\" width=\"7\" height=\"7\" data-v-3442f67f></rect></svg> Por projetos ", 2)
        ]))], 2),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["toggle-btn", { active: _ctx.viewMode === 'roles' }]),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setViewMode('roles')))
        }, [...(_cache[15] || (_cache[15] = [
          _createElementVNode("svg", {
            width: "13",
            height: "13",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, [
            _createElementVNode("circle", {
              cx: "12",
              cy: "8",
              r: "4"
            }),
            _createElementVNode("path", { d: "M4 20c0-4 3.6-7 8-7s8 3 8 7" })
          ], -1),
          _createTextVNode(" Por cargo ", -1)
        ]))], 2)
      ]),
      _createElementVNode("button", {
        class: _normalizeClass(["btn-toolbar btn-toolbar--ghost", { active: _ctx.showUnassignedUsers }]),
        type: "button",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showUnassignedUsers = !_ctx.showUnassignedUsers))
      }, _toDisplayString(_ctx.showUnassignedUsers ? 'Ocultar sem projeto' : 'Mostrar usuários sem projeto atribuído'), 3),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("button", {
          class: "btn-nav",
          type: "button",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.shiftDate(-1)))
        }, "‹"),
        _createElementVNode("input", {
          type: "date",
          class: "date-input",
          value: _ctx.selectedDate,
          onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onDateChange && _ctx.onDateChange(...args)))
        }, null, 40, _hoisted_15),
        _createElementVNode("button", {
          class: "btn-nav",
          type: "button",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.shiftDate(1)))
        }, "›"),
        _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.formatDateLabel(_ctx.selectedDate)), 1)
      ])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, "Carregando..."))
      : (_ctx.displayGroups.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, "Nenhum usuário encontrado."))
        : (_openBlock(), _createElementBlock("div", _hoisted_19, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayGroups, (group) => {
              return (_openBlock(), _createElementBlock("div", {
                key: group.groupId,
                class: "folder"
              }, [
                _createElementVNode("button", {
                  class: "folder-header",
                  type: "button",
                  onClick: ($event: any) => (_ctx.toggleFolder(group.groupId))
                }, [
                  _createElementVNode("span", _hoisted_21, [
                    (_ctx.openFolders.includes(group.groupId))
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_22, [...(_cache[16] || (_cache[16] = [
                          _createElementVNode("polyline", { points: "6 9 12 15 18 9" }, null, -1)
                        ]))]))
                      : (_openBlock(), _createElementBlock("svg", _hoisted_23, [...(_cache[17] || (_cache[17] = [
                          _createElementVNode("polyline", { points: "9 18 15 12 9 6" }, null, -1)
                        ]))]))
                  ]),
                  _cache[18] || (_cache[18] = _createElementVNode("svg", {
                    class: "folder-svg",
                    width: "16",
                    height: "16",
                    viewBox: "0 0 24 24",
                    fill: "currentColor"
                  }, [
                    _createElementVNode("path", { d: "M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" })
                  ], -1)),
                  _createElementVNode("span", _hoisted_24, _toDisplayString(group.groupName), 1),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("span", _hoisted_26, _toDisplayString(group.counters.present) + " presentes", 1),
                    _createElementVNode("span", _hoisted_27, _toDisplayString(group.counters.absent) + " ausentes", 1)
                  ]),
                  _createElementVNode("span", _hoisted_28, _toDisplayString(group.users.length), 1)
                ], 8, _hoisted_20),
                (_ctx.openFolders.includes(group.groupId))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.users, (user) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: user.username,
                          class: _normalizeClass(["user-card", { 'user-card--streak': _ctx.highlightedStreak(user) >= 3 }])
                        }, [
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                              (user.avatar)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: _ctx.$resolveUrl(user.avatar),
                                    alt: "perfil"
                                  }, null, 8, _hoisted_32))
                                : (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.initials(user.name)), 1))
                            ]),
                            _createElementVNode("div", _hoisted_34, [
                              _createElementVNode("strong", _hoisted_35, _toDisplayString(user.name), 1),
                              _createElementVNode("span", _hoisted_36, "@" + _toDisplayString(user.username), 1),
                              (_ctx.viewMode === 'projects' && user.roleName)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(user.roleName), 1))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          (_ctx.viewMode === 'projects')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["presence-pill", _ctx.presenceClass(user.status)])
                                }, _toDisplayString(_ctx.presenceLabel(user.status, user.time)), 3),
                                (user.absentStreak >= 3)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_39, " Ausente há " + _toDisplayString(user.absentStreak) + " dias ", 1))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                (user.projectAttendances.length > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                      _createElementVNode("div", _hoisted_42, "Projetos em " + _toDisplayString(_ctx.formatDateLabel(_ctx.selectedDate)) + ":", 1),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(user.projectAttendances, (project) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: project.projectId,
                                          class: _normalizeClass(["assign-chip", _ctx.assignChipClass(project.status)])
                                        }, [
                                          _cache[19] || (_cache[19] = _createElementVNode("svg", {
                                            width: "10",
                                            height: "10",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            stroke: "currentColor",
                                            "stroke-width": "2.5",
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round"
                                          }, [
                                            _createElementVNode("rect", {
                                              x: "3",
                                              y: "3",
                                              width: "18",
                                              height: "18",
                                              rx: "2"
                                            }),
                                            _createElementVNode("line", {
                                              x1: "3",
                                              y1: "9",
                                              x2: "21",
                                              y2: "9"
                                            }),
                                            _createElementVNode("line", {
                                              x1: "9",
                                              y1: "21",
                                              x2: "9",
                                              y2: "9"
                                            })
                                          ], -1)),
                                          _createTextVNode(" " + _toDisplayString(project.projectName) + " ", 1),
                                          _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.presenceLabel(project.status, project.time)), 1),
                                          (project.absentStreak >= 3)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(project.absentStreak) + " dias", 1))
                                            : _createCommentVNode("", true)
                                        ], 2))
                                      }), 128))
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_45, "Sem atribuições em projetos")),
                                (!user.hasAssignedProject)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_46, "Sem projeto atribuído"))
                                  : (user.maxAbsentStreak >= 3)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_47, "Ausente há " + _toDisplayString(user.maxAbsentStreak) + " dias", 1))
                                    : _createCommentVNode("", true)
                              ]))
                        ], 2))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]))
  ]))
}